"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ManualQuoteActivity = exports.manualQuoteTranslationMap = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const frontend_infra_localisation_1 = require("@forto-dev/frontend-infra-localisation");
const silhouette_core_1 = require("@freighthub/silhouette-core");
const useDateFormatter_1 = require("../../../util/useDateFormatter");
exports.manualQuoteTranslationMap = {
    requested: 'activity-feed_manual-quote_requested',
    declined: 'activity-feed_manual-quote_declined',
    pending: 'activity-feed_manual-quote_pending',
};
const ManualQuoteActivity = ({ activity: { declineCustomReason, declineReasons, status, validUntil }, }) => {
    const { translate } = (0, frontend_infra_localisation_1.useI18n)();
    const { formatDateShort } = (0, useDateFormatter_1.useDateFormatter)();
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [status === 'pending' && !!validUntil && ((0, jsx_runtime_1.jsxs)(silhouette_core_1.Typography, { children: [translate('activity-feed_manual-quote_valid-until'), ": ", formatDateShort(validUntil)] })), !declineCustomReason && declineReasons?.map((reason, index) => (0, jsx_runtime_1.jsx)(silhouette_core_1.Typography, { children: reason }, index)), declineCustomReason && (0, jsx_runtime_1.jsx)(silhouette_core_1.Typography, { children: declineCustomReason })] }));
};
exports.ManualQuoteActivity = ManualQuoteActivity;
//# sourceMappingURL=ManualQuoteActivity.js.map